<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.99992 11C8.99992 11.5523 8.55221 12 7.99992 12C7.44764 12 6.99992 11.5523 6.99992 11C6.99992 10.4477 7.44764 10 7.99992 10C8.55221 10 8.99992 10.4477 8.99992 11ZM6.92074 6.08541C7.00125 5.92438 7.11024 5.78617 7.25969 5.68654C7.40445 5.59004 7.63116 5.5 7.99992 5.5C8.27967 5.5 8.55283 5.58656 8.73742 5.725C8.90198 5.84842 8.99992 6.01009 8.99992 6.25C8.99992 6.42662 8.95911 6.51381 8.92275 6.56835C8.8774 6.63639 8.79916 6.71162 8.64638 6.81349C8.56999 6.86441 8.4878 6.9139 8.38746 6.97411L8.38133 6.97779C8.28763 7.03401 8.17696 7.10041 8.06823 7.1729C7.846 7.32107 7.58049 7.52712 7.37585 7.83412C7.14611 8.17878 7.23927 8.64442 7.58393 8.87417C7.92859 9.10391 8.39424 9.01075 8.62398 8.66609C8.66934 8.59803 8.74758 8.52279 8.90035 8.42093C8.97673 8.37001 9.05892 8.32052 9.15926 8.26032L9.16546 8.25659C9.25912 8.20039 9.36979 8.134 9.47847 8.06154C9.70068 7.91339 9.9662 7.70737 10.1708 7.4004C10.3845 7.07994 10.4999 6.69838 10.4999 6.25C10.4999 5.48991 10.1395 4.90158 9.63742 4.525C9.15534 4.16344 8.5535 4 7.99992 4C7.36868 4 6.84539 4.15996 6.42764 4.43846C6.01459 4.71383 5.74858 5.07562 5.5791 5.41459C5.39385 5.78507 5.54402 6.23558 5.91451 6.42082C6.28499 6.60606 6.7355 6.45589 6.92074 6.08541Z"
    fill="currentColor"
  />
</svg>
